/*
  PDP V3 helpers. Loaded only when the "Product page layout" setting is V3.

  1. Keeps the "Size: XS" value in each option legend in sync with the checked
     pill. variant-radios is never re-rendered on variant change, so the
     server-rendered value would go stale otherwise.
  2. Keeps the price inside the Add to cart button in sync with the selected
     variant. It mirrors #price-{section} (which the theme re-renders on every
     variant change) the same way the sticky ATC bar does, so sale prices and
     pack options always match what the price block shows.
  3. Animates the guarantee dropdown open/closed. Native <details> snaps, so the
     toggle is driven here; without JS it still opens, just without motion.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncOptionValues() {
    document.querySelectorAll('.product--pdp-v3 variant-radios fieldset').forEach(function (fieldset) {
      var output = fieldset.querySelector('[data-pdp-v3-option-value]');
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (output && checked && output.textContent !== checked.value) output.textContent = checked.value;
    });
  }

  function initOptionValues() {
    document.querySelectorAll('.product--pdp-v3 variant-radios').forEach(function (radios) {
      radios.addEventListener('change', syncOptionValues);
    });
    // variant-radios may auto-select a pack option on load without a change event.
    syncOptionValues();
    window.setTimeout(syncOptionValues, 300);
  }

  function readPrice(priceEl) {
    var onSale = priceEl.querySelector('.price--on-sale');
    var item = onSale
      ? priceEl.querySelector('.price__sale .price-item--sale')
      : priceEl.querySelector('.price__regular .price-item--regular');
    // "$37.50 USD" -> "$37.50" so the button label stays short.
    return item ? item.textContent.trim().replace(/\s*[A-Za-z]{3}\s*$/, '') : '';
  }

  function initButtonPrice() {
    document.querySelectorAll('.product--pdp-v3 [data-atc-price]').forEach(function (output) {
      var button = output.closest('[id^="ProductSubmitButton-"]');
      if (!button) return;
      var priceEl = document.getElementById('price-' + button.id.replace('ProductSubmitButton-', ''));
      if (!priceEl) return;

      var sync = function () {
        var amount = readPrice(priceEl);
        if (amount && output.textContent !== amount) output.textContent = amount;
      };
      new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true });
      sync();
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-pdp-v3-accordion]').forEach(function (details) {
      var summary = details.querySelector('summary');
      var body = details.querySelector('[data-pdp-v3-accordion-body]');
      if (!summary || !body || !body.animate) return;
      var animation = null;
      var opening = false;

      summary.addEventListener('click', function (event) {
        if (reduceMotion.matches) return;
        event.preventDefault();

        // Mid-animation clicks reverse from wherever the height currently is.
        opening = animation ? !opening : !details.open;
        var startHeight = details.open ? body.offsetHeight : 0;
        if (animation) animation.cancel();

        details.open = true;
        body.style.overflow = 'hidden';
        var endHeight = opening ? body.scrollHeight : 0;

        animation = body.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        animation.onfinish = function () {
          details.open = opening;
          body.style.overflow = '';
          animation = null;
        };
      });
    });
  }

  function init() {
    initOptionValues();
    initButtonPrice();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
